import { render, staticRenderFns } from "./o-polaroid.vue?vue&type=template&id=cf45d912&scoped=true&"
import script from "./o-polaroid.js?vue&type=script&lang=js&"
export * from "./o-polaroid.js?vue&type=script&lang=js&"
import style0 from "./o-polaroid.scss?vue&type=style&index=0&id=cf45d912&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf45d912",
  null
  
)

export default component.exports